import { createContext, useContext, useState, type ReactNode } from "react";

interface GameSettings {
    numOfSets: number;
    pointsPerSet: number;
    maxScore: number;
}

interface GameSettingsContextType {
    gameSettings: GameSettings;
    setGameSettings: (settings: GameSettings) => void;
}

const GameSettingsContext = createContext<GameSettingsContextType | undefined>(undefined);

export function GameSettingsProvider({ children }: { children: ReactNode }) {
    const [gameSettings, setGameSettings] = useState<GameSettings>({
        numOfSets: 0,
        pointsPerSet: 0,
        maxScore: 30,
    });

    return (
        <GameSettingsContext.Provider value={{ gameSettings, setGameSettings }}>
            {children}
        </GameSettingsContext.Provider>
    );
}

export function useGameSettings() {
    const context = useContext(GameSettingsContext);
    if (context === undefined) {
        throw new Error("useGameSettings must be used within a GameSettingsProvider");
    }
    return context;
} 